import React, { useContext, useEffect, useState } from 'react';
import cx from 'classnames';
import { NavigationHeaderContext } from '@/components/NavigationHeader/NavigationHeaderContext';
import { generateRandomStr } from '@/utils/index';
import { useRouter } from 'next/router';
import useGetUserInfo from '@/hooks/useGetUserInfo';
const HeaderNavItemConsole: React.FC = () => {
  const NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  const { uid, permission } = useGetUserInfo();
  const router = useRouter();

  const navItemArr = [];
  if (permission?.superAdmin || permission?.manageNoFaceVerify) {
    navItemArr.push({
      label: '免人脸核验人员',
      href: '/console/noCheck',
      isActive: router.pathname === '/console/noCheck' ? true : false,
    });
  }
  if (permission?.superAdmin || permission?.manageTipText) {
    navItemArr.push({
      label: '提示文案管理',
      href: '/console/text',
      isActive: router.pathname === '/console/text' ? true : false,
    });
  }
  if (permission?.superAdmin) {
    navItemArr.push({
      label: '权限管理',
      href: '/console/access',
      isActive: router.pathname === '/console/access' ? true : false,
    });
  }

  const { navItem = navItemArr } = NavigationHeaderContextProps;

  const [data, setData] = useState(navItem);

  useEffect(() => {
    if (Array.isArray(navItem)) {
      setData(navItem);
    }
  }, [navItem]);

  return (
    <div className="dr-nav-item-wrapper">
      {data.map((item) => {
        return (
          <a
            href={item.href}
            className={cx('dr-nav-item', item.isActive && 'active')}
            key={generateRandomStr()}
            rel="noreferrer"
          >
            {item.label}
          </a>
        );
      })}
    </div>
  );
};
export default HeaderNavItemConsole;
